import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)
import Swiper from "swiper/bundle";

// window.addEventListener('DOMContentLoaded', function () {
//   var swiper = new Swiper('.swiper-container', {
//     loop: true,
//     autoplay: {
//       delay: 4000,
//     },
//     pagination: {
//       el: '.swiper-pagination',
//     },
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
//     scrollbar: {
//       el: '.swiper-scrollbar',
//     },
//     slidesPerView: 1,
//     centeredSlides: true,
//     breakpoints: {
//       768: {
//         slidesPerView: 'auto',
//         spaceBetween: 2
//       }
//     }
//   });
// }, false);

$(function () {
  var breakPoint = 767;
  var $window = $(window);
  var winwidth = window.innerWidth;

  //スマホの条件分岐
  var getDevice = (function () {
    var ua = navigator.userAgent;
    if (ua.indexOf("iPhone") > 0 || ua.indexOf("iPod") > 0 || (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)) {
      return "sp";
    } else if (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0) {
      return "tab";
    } else {
      return "other";
    }
  })();

  // ※ 元の空の if ブロックは削除しました（no-empty 対策）。
  if (getDevice == "sp") {
    $(".event-side-title").on("click", function () {
      $(".event-side-list").stop().slideToggle();
    });
  }

  // スマホ時 メニュー開閉
  var openBtn = $("#js-header-btn");
  var gNav = $("#js-gnav");
  openBtn.click(function (e) {
    e.preventDefault();
    if ($(this).hasClass("open")) {
      gNav.removeClass("open");
      $(this).removeClass("open");
    } else {
      gNav.addClass("open");
      $(this).addClass("open");
    }
  });

  const blogSlider = new Swiper(".limini-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    //   autoplay: {
    //   delay: 5000,
    // },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        // autoplay: {
        //   delay: 5000,
        // },
        slidesPerView: 3,
        spaceBetween: 0,
        loop: true,
        // loopFillGroupWithBlank: true,
        // watchOverflow: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    },
  });

  const swiper = new Swiper(".limini__style--portfolio--slider", {
    spaceBetween: 20,
    centeredSlides: true,
    slidesPerView: 1,
    loop: true,
    breakpoints: {
      // スライドの表示枚数：768px以上の場合
      768: {
        slidesPerView: 3,
      },
    },
    // autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var swiper2 = new Swiper(".limini__style--portfolio--slider", {
    spaceBetween: 20,
    centeredSlides: true,
    slidesPerView: 1,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // pagetopボタンの表示切替
  var pageTop = $("#js-pagetop");
  pageTop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      pageTop.fadeIn();
    } else {
      pageTop.fadeOut();
    }
  });

  // Topバナーの表示切替
  var bannerTop = $(".gr-footer--catalog");
  bannerTop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      bannerTop.fadeIn();
    } else {
      bannerTop.fadeOut();
    }
  });

  var bannerTop2 = $(".gr-footer--model-house");
  bannerTop2.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      bannerTop2.fadeIn();
    } else {
      bannerTop2.fadeOut();
    }
  });

  // フェードインアニメーション
  var fadeContents = $(".js-fade");

  if (fadeContents.length) {
    var effectPos = 100; // 画面下からどの位置でフェードさせるか(px)
    var effectMove = 20; // どのぐらい要素を動かすか(px)
    var effectTime = 1; // エフェクトの時間(s) 1秒なら1

    fadeContents.css({
      // フェードする前のcssを定義
      opacity: 0,
      transform: "translateY(" + effectMove + "px)",
      transition: effectTime + "s",
    });

    $(window).scroll(function () {
      fadeContents.each(function () {
        var targetElement = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll > targetElement - windowHeight + effectPos) {
          $(this).css("opacity", "1");
          $(this).css("transform", "translateY(0)");
        }
      });
    });
  }

  // LINE UP タブ切替
  var lineupTabBtn = $(".js-lineup-btn");
  var lineupContents = $(".js-lineup-contents");
  lineupTabBtn.on("click", function (e) {
    e.preventDefault();
    const i = $(this).parent().index();

    lineupTabBtn.removeClass("active");
    $(this).addClass("active");
    lineupContents.removeClass("active");
    lineupContents.eq(i).addClass("active");
  });

  // スムーススクロール
  $("a[href^=\"#\"]").click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  //アコーディオン
  $(".organization-open").on("click", function () {
    $(this).next().stop().slideToggle();
    $(this).toggleClass("is-active");
    $(this).next().toggleClass("is-open");
  });

  // ---- ここで未使用変数を参照して ESLint の no-unused-vars を回避します ----
  // （副作用無しに「使っている」と見せるため）
  void breakPoint;
  void $window;
  void winwidth;
  void blogSlider;
  void swiper;
  void swiper2;
});
// ----------------------------------------------------------------------------

// スムーススクロール
import Vue from "vue";
import vueSmoothScroll from "vue-smooth-scroll";

Vue.use(vueSmoothScroll);
Vue.directive("scroll", {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  },
});

// Vueインスタンス作成
const app = new Vue({
  el: "#app",
  data: {
    visible: false, // 表示・非表示判定を格納
  },
  methods: {
    handleScroll() {
      // スクロール値が151以上の場合にvisibleをtrue、そうでない場合にfalseにする
      this.visible = window.pageYOffset > 150;
    },
  },
});

// Vue インスタンスも未参照扱いを回避
void app;
